"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateChatMessageStatus = exports.setIsWaitingForChatResponse = exports.clearChatMessages = exports.addChatMessage = exports.addAIResponse = exports.submitChatMessage = exports.askAITutor = void 0;
var chatApi_1 = require("@cdo/apps/aichat/chatApi");
var types_1 = require("@cdo/apps/aichat/types");
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("@cdo/apps/aiTutor/constants");
var registerReducers = require('@cdo/apps/redux').registerReducers;
var initialChatMessages = [
    {
        id: 0,
        role: types_1.Role.ASSISTANT,
        chatMessageText: "Hi! I'm your AI Tutor. Type your question below.",
        status: types_1.Status.OK,
    },
];
var initialState = {
    aiResponse: '',
    isWaitingForAIResponse: false,
    chatMessages: initialChatMessages,
    isWaitingForChatResponse: false,
    chatMessageError: false,
};
// THUNKS
// Compilation & Validation
exports.askAITutor = (0, toolkit_1.createAsyncThunk)('aitutor/askAITutor', function (ChatContext, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var chatApiResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (ChatContext.systemPrompt === undefined) {
                    throw new Error('systemPrompt is undefined');
                }
                if (ChatContext.studentCode === undefined) {
                    throw new Error('studentCode is undefined');
                }
                return [4 /*yield*/, (0, chatApi_1.postOpenaiChatCompletion)([
                        { role: types_1.Role.SYSTEM, content: ChatContext.systemPrompt },
                        { role: types_1.Role.USER, content: ChatContext.studentCode },
                    ], ChatContext.levelId)];
            case 1:
                chatApiResponse = _a.sent();
                thunkAPI.dispatch((0, exports.addAIResponse)(chatApiResponse === null || chatApiResponse === void 0 ? void 0 : chatApiResponse.content));
                return [2 /*return*/];
        }
    });
}); });
// General Chat
// This thunk's callback function submits a user chat message to the chat completion endpoint,
// waits for a chat completion response, and updates the user message state.
exports.submitChatMessage = (0, toolkit_1.createAsyncThunk)('aitutor/submitChatMessage', function (message, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, systemPrompt, storedMessages, newMessageId, newMessage, chatApiResponse, assistantChatMessage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                systemPrompt = constants_1.generalChatSystemPrompt;
                storedMessages = state.aiTutor.chatMessages;
                newMessageId = storedMessages[storedMessages.length - 1].id + 1;
                newMessage = {
                    id: newMessageId,
                    role: types_1.Role.USER,
                    status: types_1.Status.UNKNOWN,
                    chatMessageText: message,
                };
                thunkAPI.dispatch((0, exports.addChatMessage)(newMessage));
                return [4 /*yield*/, (0, chatApi_1.getChatCompletionMessage)(systemPrompt, newMessageId, message, storedMessages)];
            case 1:
                chatApiResponse = _a.sent();
                // Find message in chatMessages and update status.
                thunkAPI.dispatch((0, exports.updateChatMessageStatus)({
                    id: chatApiResponse.id,
                    status: chatApiResponse.status,
                }));
                // Add assistant chat messages to chatMessages.
                if (chatApiResponse.assistantResponse) {
                    assistantChatMessage = {
                        id: chatApiResponse.id + 1,
                        role: types_1.Role.ASSISTANT,
                        status: types_1.Status.OK,
                        chatMessageText: chatApiResponse.assistantResponse,
                    };
                    thunkAPI.dispatch((0, exports.addChatMessage)(assistantChatMessage));
                }
                return [2 /*return*/];
        }
    });
}); });
var aiTutorSlice = (0, toolkit_1.createSlice)({
    name: 'aiTutor',
    initialState: initialState,
    reducers: {
        addAIResponse: function (state, action) {
            state.aiResponse = action.payload;
        },
        setIsWaitingForAIResponse: function (state, action) {
            state.isWaitingForAIResponse = action.payload;
        },
        addChatMessage: function (state, action) {
            state.chatMessages.push(action.payload);
        },
        clearChatMessages: function (state) {
            state.chatMessages = initialChatMessages;
        },
        setIsWaitingForChatResponse: function (state, action) {
            state.isWaitingForChatResponse = action.payload;
        },
        updateChatMessageStatus: function (state, action) {
            var _a = action.payload, id = _a.id, status = _a.status;
            var chatMessage = state.chatMessages.find(function (msg) { return msg.id === id; });
            if (chatMessage) {
                chatMessage.status = status;
            }
        },
    },
    extraReducers: function (builder) {
        builder.addCase(exports.askAITutor.fulfilled, function (state) {
            state.isWaitingForAIResponse = false;
        });
        builder.addCase(exports.askAITutor.rejected, function (state, action) {
            state.isWaitingForAIResponse = false;
            console.error(action.error);
        });
        builder.addCase(exports.askAITutor.pending, function (state) {
            state.isWaitingForAIResponse = true;
        });
        builder.addCase(exports.submitChatMessage.fulfilled, function (state) {
            state.isWaitingForChatResponse = false;
        });
        builder.addCase(exports.submitChatMessage.rejected, function (state, action) {
            state.isWaitingForChatResponse = false;
            state.chatMessageError = true;
            console.error(action.error);
        });
        builder.addCase(exports.submitChatMessage.pending, function (state) {
            state.isWaitingForChatResponse = true;
        });
    },
});
registerReducers({ aiTutor: aiTutorSlice.reducer });
exports.addAIResponse = (_a = aiTutorSlice.actions, _a.addAIResponse), exports.addChatMessage = _a.addChatMessage, exports.clearChatMessages = _a.clearChatMessages, exports.setIsWaitingForChatResponse = _a.setIsWaitingForChatResponse, exports.updateChatMessageStatus = _a.updateChatMessageStatus;
